export const InquiryRotationPermissions = {
  ViewInquiryRotation: {
    permissionsId: "84d8c9a5-1261-45e8-794e-08dcaf947ea8",
    permissionsName: "View Inquiry Rotation",
    description: null,
    componentsId: null,
    components: null,
  },
};
